import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { links } from '[theme-lib]/links';

import { gtm } from 'apps/gtm';
import { wa, pageEventTypes } from 'apps/analytics';
import { requestLogin } from 'utils/loginAndRegistration/login';
import { reportCheckoutButtonClicked } from 'apps/header/actions/checkoutButton';

export default class TrolleyMenuFooter extends PureComponent {
  static propTypes = {
    checkoutAllowed: PropTypes.bool,
    deliverySlot: PropTypes.object,
    isBottomCheckoutVisible: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    shouldDisplayAddToList: PropTypes.bool.isRequired,
    openShoppingListsModalFromBasket: PropTypes.func.isRequired,
  };

  handleLoggedOut() {
    const { router } = this.props;

    requestLogin(router);
  }

  addTrolleyToList = () => {
    if (!this.props.isLoggedIn) {
      this.handleLoggedOut();
    }

    this.props.openShoppingListsModalFromBasket();

    gtm.trigger('gtm:uaEvent', {
      category: 'Shopping List',
      action: 'Add to Shopping lists popup opened',
    });

    wa.triggerPageEvent(pageEventTypes.QM_OPEN_SHOPPING_LIST_POPUP);
  };

  onCheckoutButtonClick = (event) => {
    const { router } = this.props;

    const redirect = router.push({
      pathname: event.target.href,
    });

    reportCheckoutButtonClicked('MOBILE_SIDEBAR_BOTTOM', redirect);
  }

  checkoutBtn = (checkoutAllowed) => {
    if (checkoutAllowed) {
      return (
        <Link
          className="btn-checkout btn-action hd-trolleyMenuFooter__btn hd-trolleyMenuFooter__btnCheckout"
          onClick={this.onCheckoutButtonClick}
          to={links.CHECKOUT}
        >
          Checkout
        </Link>
      );
    } else {
      return (
        <span
          // eslint-disable-next-line max-len
          className="btn-checkout btn-action hd-trolleyMenuFooter__btn hd-trolleyMenuFooter__btnCheckout hd-trolleyMenuFooter__btnCheckout--belowMinOrder"
        >
          Checkout
        </span>
      );
    }
  }

  checkout = (checkoutAllowed) => (
    <div className="btn-wrapper">
      {this.checkoutBtn(checkoutAllowed)}
    </div>
  );

  render() {
    const { checkoutAllowed, deliverySlot, isBottomCheckoutVisible, shouldDisplayAddToList } = this.props;

    const slotInfo = !deliverySlot && (
      <div className="btn-wrapper">
        <Link
          to={links.BOOK_DELIVERY}
          className="btn-secondary hd-trolleyMenuFooter__btn hd-trolleyMenuFooter__btn--delivery"
        >
          Book a delivery
        </Link>
      </div>
    );

    const addToList = shouldDisplayAddToList && (
      <div className="btn-wrapper">
        <button
          className="btn-secondary hd-trolleyMenuFooter__btn hd-trolleyMenuFooter__btn--shoppingList"
          onClick={this.addTrolleyToList}
        >
          Add trolley to list
        </button>
      </div>
    );

    return (
      <div className="hd-trolleyMenuFooter">
        {isBottomCheckoutVisible && this.checkout(checkoutAllowed)}
        {slotInfo}
        {addToList}
      </div>
    );
  }
}
